import { Box, Container } from '@mui/material';
import { Text } from '@qwickapps/react-framework';

export default function QuickStartPage() {
  return (
    <Container maxWidth="md">
      <Box sx={{ py: 8 }}>
        <Text variant="h4" customColor="var(--theme-text-primary)" content="Quick Start Prompt" />
        <Text customColor="var(--theme-text-secondary)" content="First prompt interface coming soon..." sx={{ mt: 2 }} />
      </Box>
    </Container>
  );
}
